import {Component, inject, Input} from "@angular/core";

@Component({
  selector: 'ag-copy-link-button',
  templateUrl: './ag-copy-link-button.component.html',
  styleUrls: ['./ag-copy-link-button.component.scss']
})
export class AgCopyLinkButtonComponent {
  @Input() data?: string;
}
